<template>
  <div>
    <button class="d-none" data-toggle="modal" data-target="#manageParks" ref="openModalManageParks"></button>
    <div class="modal fade" tabindex="-1" role="dialog" id="manageParks">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title m-0">Manage Parks</h6>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" ref="closeManageParks">
              <img src="../../../assets/Svg/close.svg" />
            </button>
          </div>
          <div class="modal-body">
            <ParksComponent ref="parksComponent" :eventId="eventId" :association_id="association_id" @close-manage-modal="closeModal"
              @update-state="handleStateUpdate" />
          </div>
          <div class="event-btns-wrapper pt-3 justify-content-end">
            <button v-if="!isDisabled" type="button" class="btn btn-primary" :disabled="isLoadingArray[0]"
              @click="manageParks(0)">
              <div v-if="isLoadingArray[0]" class="lds-dual-ring"></div>
              <div v-else>
                <img class="mr-1" src="../../../assets/Svg/save.svg" alt="save" />
                Save
              </div>
            </button>
            <button v-else type="button" class="btn btn-primary-disabled" :disabled="isLoadingArray[0]">
              <div v-if="isLoadingArray[0]" class="lds-dual-ring"></div>
              <div v-else>
                <img class="mr-1" src="../../../assets/Svg/save.svg" alt="save" />
                Save
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
    <AddPark :parentIdentifier="'ManageParksIsParent'" @open-main-modal-again="openMainModalFromAddPark" />
  </div>
</template>
<script>
import axios from "axios";
import ParksComponent from "./ParksComponent.vue";
import AddPark from "./AddPark";
export default {
  name: "ManageParks",
  components: {
    ParksComponent,
    AddPark
  },
  props: {
    eventId: {
      type: [Number, String],
    },
    association_id: {
      type: [Number, String],
    },
  },
  data() {
    return {
      isDisabled: true,
      isLoadingArray: [],
      selectedParksFromChild: [],
      showLoaderAvailableParks: 1,
      showLoaderSelectedParks: 1,
      availableParks: [],
      selectedParks: [],
    }
  },

  methods: {
    handleStateUpdate({ isDisabled, selectedParks }) {
      this.isDisabled = isDisabled;
      this.selectedParksFromChild = selectedParks;
    },
    closeModal() {
      var elem = this.$refs.closeManageParks;
      if (elem) {
        elem.click();
      }
    },
    openMainModalFromAddPark(id) {
      if (id === "ManageParksIsParent") {
        var elem = this.$refs.openModalManageParks;
        if (elem) {
          elem.click();
          const child = this.$refs.parksComponent;
          if (child) {
            child.getPlayingFacilities();
            child.getPlayingFacilityForAssociation()
          }
        }
      }
    },
    async getPlayingFacilityForAssociation() {
      try {
        this.showLoaderSelectedParks = 1;
        this.showLoaderSelectedParks = 1;

        // Prepare the parameters
        const params = {
          event_id: this.eventId,
          association_id: this.association_id,
        };

        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}associationEvent/getEventPlayingFacility?event_id=${this.eventId}&association_id=${this.association_id}`,
          { params } // Send parameters as query params
        );

        if (response.data.statusCode === 200) {
          this.selectedParks = Object.values(response.data.data.parkDetails);
          this.showLoaderSelectedParks = 0;
        }
        else if (response.data.statusCode === 404) {
          this.closeModal();
          // this.$alert(response.data.message, 'Error');
          // this.$router.push({ name: "Teams" });
        }
        else {
          this.errorMessage = response.data.message || "Unknown error occurred";
          this.showLoaderSelectedParks = 0;
        }
      } catch (error) {
        this.errorMessage = "Failed to fetch data";
        this.showLoaderSelectedParks = 0;
      }
    },
    async getPlayingFacilities() {
      try {
        this.showLoaderAvailableParks = 1;
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}associationEvent/getParksForEventManagement?event_id=${this.eventId}&association_id=${this.association_id}`
        );

        if (response.data.statusCode === 200) {
          this.availableParks = Object.values(response.data.data.parks);
          this.showLoaderAvailableParks = 0;
        } else if (response.data.statusCode === 404) {
          this.closeModal();
          this.$alert(response.data.message, 'Error');
          this.$router.push({ name: "Teams" });
        } else {
          this.errorMessage = response.data.message || "Unknown error occurred";
          this.showLoaderAvailableParks = 0;
        }
      } catch (error) {
        this.errorMessage = "Failed to fetch data";
        this.showLoaderAvailableParks = 0;
      }
    },
    async manageParks(index) {
      this.$set(this.isLoadingArray, index, true);
      try {
        const url = `${process.env.VUE_APP_API_URL}associationEvent/createEventPark`;
        const response = await axios.post(url, {
          event_id: this.eventId,
          selectedParks: this.selectedParksFromChild,
          association_id: this.association_id,
        });

        // Handle the response based on statusCode
        if (response.data.statusCode === 200) {
          this.closeModal();
          this.$root.$emit("selectedParkEmit");
        } else if (response.data.statusCode === 404) {
          this.closeModal();
          this.$alert(response.data.message, 'Error');
          this.$router.push({ name: "Teams" });
        } else {
          this.errorMessage = response.data.message || "Unknown error occurred";
          this.$set(this.isLoadingArray, index, false);
        }
      } catch (error) {
        console.error("Error saving selected parks:", error);
      } finally {
        this.$set(this.isLoadingArray, index, false);
      }
    },
  },

  mounted() {
    this.$root.$on("openManageParksModal", (params) => {
      // Destructure the parameters
      const { eventId, association_id } = params || {};

      // Store these values if needed
      this.eventId = eventId;
      this.association_id = association_id;

      var elem = this.$refs.openModalManageParks;
      if (elem) {
        elem.click();
      }
    });
  },
};
</script>
